import { useState, forwardRef } from "react";
import { Select } from "antd";

import ChevronDownIcon from "@/icons/ChevronDownIcon";
import CloseCircleIcon from "@/icons/CloseCircleIcon";

const CustomSelect = forwardRef(
  ({ allowClear, onOpenChange, open, options = [], ...props }, ref) => {
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    const isOpen = open ?? internalIsOpen;

    const handleOpenChange = (nextOpen) => {
      setInternalIsOpen(nextOpen);
      onOpenChange?.(nextOpen);
    };

    return (
      <Select
        ref={ref}
        suffixIcon={
          <ChevronDownIcon
            style={{
              fontSize: 14,
              transform: `rotate(${isOpen ? "-180deg" : "0"})`,
            }}
          />
        }
        allowClear={allowClear ? { clearIcon: <CloseCircleIcon /> } : false}
        open={open}
        onOpenChange={handleOpenChange}
        options={options?.map(
          ({
            uuid,
            label,
            name,
            value,
            key,
            icon,
            color,
            style_key,
            display_label,
            disabled,
            email,
            ...rest
          }) => ({
            uuid,
            label,
            name,
            value,
            icon,
            color,
            style_key,
            display_label,
            disabled,
            email,
            ...rest,
          }),
        )}
        {...props}
      />
    );
  },
);

export default CustomSelect;
